import React from 'react';
import { Component } from 'react';

export default class PlaceHolder extends Component {
  render() {
    const cards = [];
    const aside = [];
    for (let index = 0; index < 12; index++) {
      cards.push(
        <li key={index} className="bg-white dark:bg-light-500 rounded  border border-gray-200 dark:border-gray-700">
          <div className="h-32 bg-gray-200 dark:bg-light-700 rounded-tr rounded-tl animate-pulse"></div>
          <div className="p-5">
            <div className="h-6 rounded-sm bg-gray-200 dark:bg-light-700 animate-pulse mb-4"></div>
            <div className="grid grid-cols-4 gap-1">
              <div className="col-span-3 h-4 rounded-sm bg-gray-200 dark:bg-light-700 animate-pulse"></div>
              <div className="h-4 rounded-sm bg-gray-200 dark:bg-light-700 animate-pulse"></div>
              <div className="col-span-2 h-4 rounded-sm bg-gray-200 dark:bg-light-700 animate-pulse"></div>
              <div className="col-span-2 h-4 rounded-sm bg-gray-200 dark:bg-light-700 animate-pulse"></div>
              <div className="h-4 rounded-sm bg-gray-200 dark:bg-light-700 animate-pulse"></div>
              <div className="col-span-3 h-4 rounded-sm bg-gray-200 dark:bg-light-700 animate-pulse"></div>
              <div className="col-span-2 h-4 rounded-sm bg-gray-200 dark:bg-light-700 animate-pulse"></div>
              <div className="h-4 rounded-sm bg-gray-200 dark:bg-light-700 animate-pulse"></div>
            </div>
          </div>
        </li>
      );
    }
    for (let index = 0; index < 3; index++) {
      aside.push(
        <li key={index} className="bg-white dark:bg-light-500 rounded  border border-gray-200 dark:border-gray-700">
          <div className="h-32 bg-gray-200 dark:bg-light-700 rounded-tr rounded-tl animate-pulse"></div>
          <div className="p-5">
            <div className="h-6 rounded-sm bg-gray-200 dark:bg-light-700 animate-pulse mb-4"></div>
            <div className="grid grid-cols-4 gap-1">
              <div className="col-span-3 h-4 rounded-sm bg-gray-200 dark:bg-light-700 animate-pulse "></div>
              <div className="h-4 rounded-sm bg-gray-200 dark:bg-light-700 animate-pulse"></div>
              <div className="col-span-2 h-4 rounded-sm bg-gray-200 dark:bg-light-700 animate-pulse"></div>
              <div className="col-span-2 h-4 rounded-sm bg-gray-200 dark:bg-light-700 animate-pulse"></div>
              <div className="h-4 rounded-sm bg-gray-200 dark:bg-light-700 animate-pulse"></div>
              <div className="col-span-3 h-4 rounded-sm bg-gray-200 dark:bg-light-700 animate-pulse"></div>
              <div className="col-span-2 h-4 rounded-sm bg-gray-200 dark:bg-light-700 animate-pulse"></div>
              <div className="h-4 rounded-sm bg-gray-200 dark:bg-light-700 animate-pulse"></div>
            </div>
          </div>
        </li>
      );
    }
    return <div>
              <header>
                <div className="bg-white dark:bg-light-500 rounded  border border-gray-200 dark:border-gray-700">
                  <div className="bg-gray-300 dark:bg-light-800 rounded-tr rounded-tl animate-pulse" style={{"height": "3rem"}}></div>
                  <div className="bg-gray-100 dark:bg-light-600" style={{"height": "3rem"}}></div>
                </div>
              </header>
              <main className="min-h-screen grid grid-cols-12 gap-4 container mx-auto px-4 my-8">
                <section className="col-span-full md:col-span-8 xl:col-span-9">
                  <ul className="grid grid-cols-1 gap-4">{cards}</ul>
                </section>
                <aside className="col-span-full md:col-span-4 xl:col-span-3 ">
                  <ul className="grid grid-cols-1 gap-4">{aside}</ul>
                </aside>
              </main>
            </div>
  }
}
